import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { OrderStatusModel } from '@libs/shared/models';
import { OrderHistoryHelperService } from '../order-history-helper.service';

@Component({
  selector: 'ui-order-history-status',
  templateUrl: './order-history-status.component.html',
  styleUrls: ['./order-history-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderHistoryStatusComponent {
  public readonly helperService: OrderHistoryHelperService = inject(OrderHistoryHelperService);
  public orderStatus: InputSignal<OrderStatusModel | undefined> = input.required();
  public orderStatusText: Signal<string> = computed(() => this.helperService.translateOrderStatus(this.orderStatus()));
  public orderStatusClass: Signal<string> = computed(() => this.helperService.orderStatusStyle(this.orderStatus()));
}
